import {
  dateFromISOString,
  formatDate,
  getDateUtc,
} from '@wz-utilities/date.utilities';

export class DateProjector {
  public static fromApiToApp(date: string): string | null {
    if (!date) {
      return null;
    }

    return formatDate(dateFromISOString(date) ?? new Date());
  }

  public static fromAppToApi(date: string | null | undefined): string | null {
    if (!date) {
      return null;
    }

    return getDateUtc(date).toISOString();
    //return formatDate(dateFromISOString(date), "yyyy-MM-dd");
  }
}
